"use client";

import { useState } from "react";
import Form from "next/form";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { updateNotificationsAction } from "../actions";
import DialogAlert from "./DialogAlert";
import SubmitButton from "./SubmitButton";
import { UserList } from "./UserList";
import { User } from "@/api/users";

export default function UpdateNotificationsButton({
  users,
}: {
  users: User[];
}) {
  const [open, setOpen] = useState(false);
  const [alertVisible, setAlertVisible] = useState<boolean>(false);

  const handleClose = () => {
    setAlertVisible(false);
    setOpen(false);
  };

  const handleAction = async (formData: FormData) => {
    const result = await updateNotificationsAction(formData);
    if (result.success) {
      handleClose();
    } else {
      setAlertVisible(true);
    }
  };

  return (
    <>
      <Button variant="outlined" color="primary" onClick={() => setOpen(true)}>
        Update Notifications
      </Button>
      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <Form action={handleAction}>
          <DialogAlert
            message="There was a problem updating notification preferences"
            setVisible={setAlertVisible}
            visible={alertVisible}
          />
          <DialogTitle>Update Notification Preferences</DialogTitle>
          <DialogContent>
            <p>This will effect the following users:</p>
            <UserList users={users} />
            {users.map((user) => (
              <input key={user.id} type="hidden" name="ids" value={user.id} />
            ))}
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={true}
                    name="requires_account_summary_notifications"
                  />
                }
                label="Account"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={true}
                    name="requires_signals_notifications"
                  />
                }
                label="Signals"
              />
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" type="button">
              Cancel
            </Button>
            <SubmitButton label="Update" pendingLabel="Updating..." />
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
}
